document.addEventListener('DOMContentLoaded', () => {
  function initProgress(slideshowEl) {
    const progressFill = slideshowEl.querySelector('.slideshow-progress-bar__fill');
    if (!progressFill) return;

    const speedAttr = slideshowEl.getAttribute('autoplay');
    const speed = parseFloat(speedAttr || '5') * 1000;
    const isHomepageHero = Boolean(slideshowEl.closest('[id*="__slideshow_TmKxFd"]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    let pausedAt = null;
    let startTime = null;
    let isPaused = false;
    let customInterval = null;
    let reducedMotionActive = isHomepageHero && reducedMotion.matches;
    let isPointerInside = false;
    let isFocusInside = false;
    let pauseRequestFrame = null;
    let transitionObserver = null;

    // Blockera slideshowens egna mouseenter/mouseleave (suspend/resume)
    slideshowEl.removeEventListener('mouseenter', slideshowEl.suspend);
    slideshowEl.removeEventListener('mouseleave', slideshowEl.resume);

    function advanceSlide() {
      if (isPaused || document.hidden) return;
      slideshowEl.next();
    }

    function startCustomInterval() {
      clearInterval(customInterval);
      if (reducedMotionActive) return;
      customInterval = setInterval(advanceSlide, speed);
    }

    function startProgress() {
      if (isHomepageHero && (document.hidden || isPointerInside || isFocusInside)) return;

      if (reducedMotionActive) {
        clearInterval(customInterval);
        customInterval = null;
        pausedAt = null;
        startTime = null;
        isPaused = true;
        progressFill.style.transitionDuration = '0ms';
        progressFill.style.width = '100%';
        progressFill.classList.remove('is-animating');
        return;
      }

      pausedAt = null;
      startTime = Date.now();
      isPaused = false;

      startCustomInterval();

      progressFill.classList.remove('is-animating');
      progressFill.style.transitionDuration = '0ms';
      progressFill.style.width = '100%';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          progressFill.style.transitionDuration = speed + 'ms';
          progressFill.classList.add('is-animating');
          progressFill.style.width = '0%';
        });
      });
    }

    function pauseProgress() {
      if (isPaused) return;
      isPaused = true;

      // Pausa slideshowens timer
      clearInterval(customInterval);
      customInterval = null;

      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, 1 - elapsed / speed);
      pausedAt = remaining;

      progressFill.style.transitionDuration = '0ms';
      progressFill.style.width = (remaining * 100) + '%';
      progressFill.classList.remove('is-animating');
    }

    function cancelDeferredPause() {
      if (pauseRequestFrame !== null) {
        cancelAnimationFrame(pauseRequestFrame);
        pauseRequestFrame = null;
      }

      transitionObserver?.disconnect();
      transitionObserver = null;
    }

    function pauseAfterTransition() {
      cancelDeferredPause();

      // Ge slideshowen två bildrutor att markera en precis påbörjad övergång.
      // Om den redan glider väntar vi tills bilden ligger helt på plats.
      pauseRequestFrame = requestAnimationFrame(() => {
        pauseRequestFrame = requestAnimationFrame(() => {
          pauseRequestFrame = null;

          if (!isPointerInside && !isFocusInside) return;

          if (!slideshowEl.hasAttribute('transitioning')) {
            pauseProgress();
            return;
          }

          transitionObserver = new MutationObserver(() => {
            if (slideshowEl.hasAttribute('transitioning')) return;

            transitionObserver?.disconnect();
            transitionObserver = null;

            if (isPointerInside || isFocusInside) {
              pauseProgress();
            }
          });

          transitionObserver.observe(slideshowEl, {
            attributes: true,
            attributeFilter: ['transitioning'],
          });
        });
      });
    }

    function resumeProgress() {
      if (
        reducedMotionActive ||
        slideshowEl.paused ||
        document.hidden ||
        (isHomepageHero && (isPointerInside || isFocusInside)) ||
        !isPaused ||
        pausedAt === null
      ) {
        return;
      }
      isPaused = false;

      const remainingTime = pausedAt * speed;
      startTime = Date.now() - (speed - remainingTime);

      // Starta timer med återstående tid, sedan normal intervall
      customInterval = setTimeout(() => {
        if (!isPaused) {
          slideshowEl.next();
          startCustomInterval();
        }
      }, remainingTime);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          progressFill.style.transitionDuration = remainingTime + 'ms';
          progressFill.classList.add('is-animating');
          progressFill.style.width = '0%';
        });
      });
    }

    // Stoppa slideshowens egna autoplay
    slideshowEl.suspend();

    startProgress();

    ['slidechange', 'slide:changed', 'sliderMoved', 'change'].forEach(eventName => {
      slideshowEl.addEventListener(eventName, () => startProgress());
    });

    const observer = new MutationObserver(() => startProgress());
    const dots = slideshowEl.querySelectorAll('[ref="dots[]"]');
    dots.forEach(dot => {
      observer.observe(dot, { attributes: true, attributeFilter: ['aria-selected'] });
    });

    if (isHomepageHero) {
      slideshowEl.addEventListener('mouseenter', () => {
        isPointerInside = true;
        pauseAfterTransition();
      });
      slideshowEl.addEventListener('mouseleave', () => {
        isPointerInside = false;
        if (!isFocusInside) cancelDeferredPause();
        resumeProgress();
      });
      slideshowEl.addEventListener('focusin', () => {
        isFocusInside = true;
        pauseAfterTransition();
      });
      slideshowEl.addEventListener('focusout', (event) => {
        if (!slideshowEl.contains(event.relatedTarget)) {
          isFocusInside = false;
          if (!isPointerInside) cancelDeferredPause();
          resumeProgress();
        }
      });

      const handleReducedMotion = (event) => {
        reducedMotionActive = event.matches;
        if (reducedMotionActive) {
          pauseProgress();
        } else {
          startProgress();
        }
      };

      if (typeof reducedMotion.addEventListener === 'function') {
        reducedMotion.addEventListener('change', handleReducedMotion);
      } else {
        reducedMotion.addListener(handleReducedMotion);
      }

      slideshowEl.querySelector('.icon-pause')?.addEventListener('click', pauseProgress);
      slideshowEl.querySelector('.icon-play')?.addEventListener('click', () => {
        window.setTimeout(startProgress, 0);
      });
    } else {
      slideshowEl.addEventListener('mouseenter', pauseProgress);
      slideshowEl.addEventListener('mouseleave', resumeProgress);
    }

    document.addEventListener('visibilitychange', () => {
      document.hidden ? pauseProgress() : resumeProgress();
    });
  }

  document.querySelectorAll('slideshow-component[autoplay]').forEach(initProgress);
});
